import {
  ThemeBackground,
  ThemePrimary,
  ThemeSecondary,
  ThemeTertiary,
} from '../../../context/theme/ThemeConstantsUpdated';
import { ColorScheme } from '../constants';

const { primaryBackground } = ThemePrimary;
const { mainBackgroundInverted, secondaryBackground } = ThemeBackground;
const { secondaryBackground: secondaryBackgroundAlt } = ThemeSecondary;
const { tertiaryBackground } = ThemeTertiary;

export function getBackgroundClassFromSubTheme(subTheme: string | undefined) {
  if (subTheme === ColorScheme.default) {
    return secondaryBackground;
  } else if (subTheme === ColorScheme.inverted) {
    return mainBackgroundInverted;
  } else if (subTheme === ColorScheme.primary) {
    return primaryBackground;
  } else if (subTheme === ColorScheme.secondary) {
    return secondaryBackgroundAlt;
  } else if (subTheme === ColorScheme.tertiary) {
    return tertiaryBackground;
  } else {
    return secondaryBackground;
  }
}
